import React from "react"

function NewMexico() {
    return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="62" height="80" viewBox="0 0 62 80">
            <path d="M26.48 59.6l-0.8-1.84h32.080l-0.16-52.4h-25.36l-25.52-0.96-2.72 59.68 7.36 0.32 0.32-4.8 15.44 0.56z"></path>
        </svg>
    )
}

export default NewMexico